define('modules/accounts/groups/model',['require','exports','module','app','env','base/model','lodash','helpers/viewHelpers'],function (require, exports, module) {
  "use strict";

  var app = require("app");
  var Config = require("env");
  var BaseModel = require("base/model");
  var _ = require("lodash");
  var viewHelpers = require("helpers/viewHelpers");

  var model = BaseModel.extend({
    initialize: function () {
      this.initRequestEvents();
    },

    defaults: {
      selectedCompany: null,
    },

    urlRoot: function () {
      var url = Config.backendUrl + "/accounts/groups";
      if (this.groupId !== undefined && this.groupId !== "0") {
        url = url + "/" + this.groupId;
      }
      return url;
    },

    hasServices: function () {
      var services = $.makeArray(this.get("services"));
      return services.length > 0;
    },

    getFirstService: function () {
      var service = null;
      if (this.hasServices()) {
        var serviceArray = $.map(this.get("services"), function (value, index) {
          return [value];
        });
        service = serviceArray[0].name;
      }
      return service;
    },

    getService: function (serviceName) {
      var service;
      if (this.hasServices()) {
        service = _.find(this.get("services"), function (currentService) {
          return (
            currentService.name.toLowerCase() === serviceName.toLowerCase()
          );
        });
      }
      return service;
    },

    getActiveCompaniesFromService: function (serviceName) {
      return _.filter(
        this.getService(serviceName).companies,
        function (company) {
          return company.activeServiceCompany;
        }
      );
    },

    hasService: function (serviceName) {
      var service = this.getService(serviceName);
      return (service && service.activeServiceGroup) === true;
    },

    hasServiceCompany: function (serviceName, companyId) {
      var companyWithService = true; //byDefault
      var service = this.getService(serviceName);
      if (companyId) {
        companyWithService = service.companies[companyId];
      }
      return (
        this.hasService(serviceName) &&
        companyWithService &&
        this.getNumCompanies(serviceName) > 0
      );
    },

    getServiceNumberProperty: function (serviceName, property) {
      var service = this.getService(serviceName);
      if (service) {
        return service[property];
      }
      return 0;
    },

    setGroupId: function (groupId) {
      this.groupId = groupId;
    },

    getNumUsers: function (serviceName) {
      return this.getServiceNumberProperty(serviceName, "numUsers");
    },

    getMaxUsers: function (serviceName) {
      return this.getServiceNumberProperty(serviceName, "maxUsers");
    },

    getNumCompanies: function (serviceName) {
      return this.getServiceNumberProperty(serviceName, "numCompanies");
    },

    getMaxCompanies: function (serviceName) {
      return this.getServiceNumberProperty(serviceName, "maxCompanies");
    },

    getDaysToExpiration: function (serviceName) {
      var daysToExpiration,
        service = this.getService(serviceName);
      if (service && service.endDate) {
        daysToExpiration = viewHelpers.getDaysToExpirationByEndDate(
          service.endDate
        );
      }
      return daysToExpiration;
    },

    getMdirectorType: function () {
      var service = this.getService("MDirector");
      return service.type;
    },

    isMdirectorStarter: function () {
      return this.getMdirectorType() === "starter";
    },

    isMdirectorPremium: function () {
      return this.getMdirectorType() === "premium";
    },

    canActivateTrans: function (companyId) {
      return (
        this.hasServiceCompany("MDirector", companyId) &&
        !this.isMdirectorStarter()
      );
    },

    isCPSAgreementsAccepted: function () {
      if (!this.get("agreements")) {
        return false;
      }
      var accepted = false;
      var cpsLabel = this.isAppSumo() ? "APPSUMO" : "CPS";
      _.each(this.get("agreements"), function (agreement) {
        if (agreement.name == cpsLabel && agreement.accepted) {
          accepted = true;
        }
      });

      return accepted;
    },
    isAppSumo: function () {
      if (!this.get("isAppSumo")) {
        return false;
      }
      return true;
    },

    canPayWithStripe: function () {
      return parseInt(this.get("enableStripePayments")) === 1;
    },

    checkApiIsEnabled: function () {
      return this.get("apiAccessEnabled");
    },
  });

  module.exports = model;
});

